<template>
<img class="com-avatar" :src="path" :style="avatarStyle" alt="用户头像" />
</template>

<script>
import VueTypes from 'vue-types'

/**
 * 头像图片
 * @desc 根据设置返回圆形头像图片，如果没有头像地址采用默认头像图片
 * @module component/Avatar
 * @example <Avatar :src="avatarUrl" :size="20" />
 */
export default {
  name: 'avatar',
  /**
   * 传入数据
   * @property {String}  [src]        头像地址
   * @property {Number}  [size=100]   宽高尺寸
   */
  props: {
    src: VueTypes.string.def(''),
    size: VueTypes.number.def(45)
  },
  /**
   * 计算属性
   * @prop {String} path         头像地址，如果没有采用默认头像
   * @prop {Object} avatarStyle  头像样式，包含宽、高、圆角
   */
  computed: {
    path () {
      return this.src || require('../assets/img/default-avatar.png')
    },
    avatarStyle () {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/css/common';

.com-avatar {
  display: block;
  background: #D0D4D7;
  border-radius: 100%;
}
</style>

